/**
 * Compression utility for COMPRESSED_JSON columns using lz-string.
 */

import LZString from 'lz-string';

export class Compression {
  static compress(data: unknown): string {
    const json = JSON.stringify(data);
    return LZString.compressToUTF16(json);
  }

  static decompress<T>(compressed: string): T {
    const json = LZString.decompressFromUTF16(compressed);
    if (!json) {
      throw new Error('Failed to decompress data');
    }
    return JSON.parse(json) as T;
  }

  static getCompressionRatio(original: string, compressed: string): number {
    return compressed.length / original.length;
  }

  static compressIfWorthIt(data: unknown): { value: string; compressed: boolean } {
    const json = JSON.stringify(data);
    const compressed = LZString.compressToUTF16(json);

    if (compressed.length < json.length * 0.8) {
      return { value: compressed, compressed: true };
    }
    return { value: json, compressed: false };
  }
}
